import styled from 'styled-components'

export const DashboardWelcome = styled.div`
	margin: 0px 0 48px;
`
